import { ConnectionEvent } from "@noya-app/state-manager";
import React from "react";
import { ObjectInspector, ObjectLabel } from "react-inspector";
import { getStateInspectorTheme } from "../inspectorTheme";
import { ObjectRootLabel } from "../ObjectRootLabel";
import { StateInspectorButton } from "../StateInspectorButton";
import {
  StateInspectorDisclosureRowInner,
  StateInspectorDisclosureSection,
} from "../StateInspectorDisclosureSection";
import { StateInspectorRow } from "../StateInspectorRow";

export function EventsSection<S>({
  showEvents,
  setShowEvents,
  colorScheme,
  eventsContainerRef,
  connectionEvents,
  paused,
  onTogglePaused,
}: {
  showEvents: boolean;
  setShowEvents: (value: boolean) => void;
  colorScheme: "light" | "dark";
  eventsContainerRef: React.RefObject<HTMLDivElement | null>;
  connectionEvents: ConnectionEvent<S>[];
  paused: boolean;
  onTogglePaused: () => void;
}) {
  const theme = getStateInspectorTheme(colorScheme);

  return (
    <StateInspectorDisclosureSection
      open={showEvents}
      setOpen={setShowEvents}
      title="Events"
      colorScheme={colorScheme}
      right={
        <StateInspectorButton theme={theme} onClick={onTogglePaused}>
          {paused ? "Resume" : "Pause"}
        </StateInspectorButton>
      }
    >
      <StateInspectorDisclosureRowInner ref={eventsContainerRef}>
        {paused && (
          <div
            style={{
              padding: "4px 12px",
              fontSize: "11px",
              opacity: 0.7,
            }}
          >
            Event streaming paused
          </div>
        )}
        {connectionEvents?.map((event, index) =>
          event.type === "stateChange" ? (
            <StateInspectorRow key={index} colorScheme={colorScheme}>
              connection:{" "}
              <span style={{ fontStyle: "italic" }}>
                {event.state.toLowerCase()}
              </span>
            </StateInspectorRow>
          ) : (
            <StateInspectorRow
              key={index}
              colorScheme={colorScheme}
              variant={event.type === "send" ? "up" : "down"}
              style={{
                padding: "0px 12px 1px",
              }}
            >
              <ObjectInspector
                data={event.type === "error" ? event.error : event.message}
                theme={theme}
                nodeRenderer={({ depth, name, data, isNonenumerable }: any) => {
                  const direction = event.type === "send" ? "up" : "down";

                  return depth === 0 ? (
                    <ObjectRootLabel direction={direction} data={data} />
                  ) : (
                    <ObjectLabel
                      direction={direction}
                      name={name}
                      data={data}
                      isNonenumerable={isNonenumerable}
                    />
                  );
                }}
              />
            </StateInspectorRow>
          )
        )}
        {!connectionEvents?.length && (
          <div
            style={{
              padding: "12px",
              fontSize: "12px",
              display: "flex",
              flexDirection: "column",
              gap: "4px",
            }}
          >
            <span>No recorded events</span>
          </div>
        )}
      </StateInspectorDisclosureRowInner>
    </StateInspectorDisclosureSection>
  );
}
